import { render } from "./GruposPrecioView.vue?vue&type=template&id=279126ac&scoped=true"
import script from "./GruposPrecioView.vue?vue&type=script&lang=js"
export * from "./GruposPrecioView.vue?vue&type=script&lang=js"

import "./GruposPrecioView.vue?vue&type=style&index=0&id=279126ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279126ac"]])

export default __exports__